export enum PERIOD_ENUM {
  'month' = 'month',
  'year' = 'year'
}

export const PERIOD_ENUM_VALUES = Object.values(PERIOD_ENUM);
